import { useEffect } from "react";
import { useLazyGetSelfEvalutionIdByAppIdQuery } from "../../../../../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { useApplicationId } from "./useApplicationId";

export function useSelfEvaluationMeta() {
    const applicationId = useApplicationId();

    const [getData, { data, isLoading }] = useLazyGetSelfEvalutionIdByAppIdQuery();
    useEffect(() => {
        if (applicationId > 0) getData(applicationId);
    }, [applicationId]);

    return {
        selfEvaluationId: data?.selfEvaluationId ?? null,
        templateId: data?.templateId ?? null,
        isLoading
    };
}